export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/chevron-right-white.8d02fa4a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};